module.exports = __webpack_public_path__ + "static/roseRight-f886266ffdc3ae4fb25f87a86bf16a89.png";